function closedFunc(cartData, code){
  let checkoutURL = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=pepperandwits.myshopify.com';
  //let checkoutURL = '/r/checkout?myshopify_domain=myshopify_domain=pepperandwits.myshopify.com';

  checkoutURL += '&cart_token='+cartData;
  checkoutURL += '&discount='+code;

  sessionStorage.setItem('checkoutURL', checkoutURL);

  window.location.href = checkoutURL;
}


(function(window) {

  // Register remove() method for IE
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  // Query parameter management
  function Query(input) {
    this.input = input;
    
    console.log("input: " + input);

    this.fetch = function(key, defaultValue) {
      key = key.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var input = "[\\?&]" + key + "=([^&#]*)";
      var regex = new RegExp(input);
      var token = regex.exec(this.input);

      if (token == null) {
        return (defaultValue !== undefined) ? defaultValue : null
      } else {
        console.log("token: " + token);
        return token[1];
      }
    };
  }

  function Popup(link, width, height, parentWidth, parentHeight) {
    var screenLeft  = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var screenTop   = window.screenTop !== undefined  ? window.screenTop  : screen.top;

    var left  = ((parentWidth / 2) - (width / 2)) + screenLeft;
    var top   = ((parentHeight / 2) - (height / 2)) + screenTop;
    console.log("Popup link:", link);
    var opened = window.open(link, "ID.me", 'scrollbars=yes, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
    
    


    if (window.focus) opened.focus();
    
    
    
    if(opened.closed) {
      console.log("window closed");
/*     
        console.log('closed');
      
      	// GET SESSION STORAGE
      
      	let checkoutURL = sessionStorage.getItem('checkoutURL');
      console.log('checkoutURL:' + checkoutURL);
      	window.location.href = checkoutURL;
*/   
    }
    
    
    
  }

  // export modules
  if (window.IDme === undefined) window.IDme = {};

  IDme.Util = {
    Popup: Popup,
    Query: Query
  };

})(window);


